//gardlistdev : client = 0487243b-a1f9-40bc-aecf-910e29c128b7
//gardlistprod : client = 48c6cc19-6b0e-45f6-ad50-eeba26eba1ac
export const msalConfig = {
    authority: "https://login.microsoftonline.com/f90e0dc6-964f-4774-9882-66c636e396f7",
    clientId: ((window.location.href.indexOf("test") > -1 || window.location.href.indexOf("localhost") > -1) ? "6cc23774-7d17-4ba1-9c21-504b7b6418cd" : "48c6cc19-6b0e-45f6-ad50-eeba26eba1ac"),
    redirectUri: document.baseURI
};
